import React, { useEffect, useState } from 'react'
import { Tabs, Tab, Spinner } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import LinkScriptDashboard from './link-script-dashboard'
import LinkScriptSettings from './link-script-settings/link-script-settings'
import { IPublisher } from './types'
import useFetch from '../../../_fetch'

const LinkScriptPage: React.FC = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { doFetch } = useFetch()

    const [publishers, setPublishers] = useState<IPublisher[]>([])
    const [loading, setLoading] = useState<boolean>(true) // ny state til loading

    useEffect(() => {
        const fetchPublishers = async () => {
            try {
                const resPub = await doFetch('/publisher-campaigns/all')
                if (resPub.status >= 400) throw await resPub.text()

                const data = await resPub.json()
                setPublishers(data)
            } catch (err) {
                console.error('Failed to fetch publishers:', err)
            } finally {
                setLoading(false) // stop spinner når fetch er færdig
            }
        }
        fetchPublishers()
    }, [])

    const activeKey =
        location.pathname === '/link-script/settings'
            ? 'settings'
            : 'overview'

    const handleSelect = (key: string | null) => {
        if (key === 'overview') navigate('/link-script')
        if (key === 'settings') navigate('/link-script/settings')
    }

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        )
    }

    return (
        <div>
            <Tabs activeKey={activeKey} onSelect={handleSelect} className="mb-3">
                <Tab eventKey="overview" title="Overview" />
                <Tab eventKey="settings" title="Settings" />
            </Tabs>

            {activeKey === 'overview' && <LinkScriptDashboard publishers={publishers} />}
            {activeKey === 'settings' && <LinkScriptSettings publishers={publishers} />}
        </div>
    )
}

export default LinkScriptPage
